import { memo } from 'react';
import { UsageModel } from '@bymason/controller-api-hooks';
import {
  Box,
  Card,
  Divider,
  Stack,
  UxCircleArrowDown,
  UxCircleArrowUp,
} from '@bymason-private/legacy-pattern-components';
import CardInfo from './card-info';

interface UsageSummaryBlockProps {
  usageByDay: UsageModel[];
}

export default memo(function UsageSummaryBlock({ usageByDay }: UsageSummaryBlockProps) {
  const grandTotal = usageByDay.reduce((tally, day) => tally + day.total, 0);
  const uploadTotal = usageByDay.reduce((tally, day) => tally + day.upload, 0);
  const downloadTotal = usageByDay.reduce((tally, day) => tally + day.download, 0);

  return (
    <Card
      sx={(theme) => ({
        display: 'flex',
        padding: 3,
        width: 'fit-content',
        [theme.breakpoints.down(1140)]: {
          width: '100%',
        },
      })}
      variant='outlined'
    >
      <Stack
        className='MasonUsageSummaryCard-root'
        sx={{
          backgroundColor: (theme) => theme.palette.primary.light,
          margin: 'auto',
          padding: 2,
          width: 'fit-content',
        }}
        alignItems='center'
        alignSelf='center'
        spacing={1}
      >
        <CardInfo caption='Used' value={grandTotal} />
        <Box width='fit-content'>
          <Divider sx={{ marginBottom: 2 }} flexItem light />
          <Stack direction='row' divider={<Divider flexItem light orientation='vertical' />} spacing={1.5}>
            <CardInfo
              caption='Upload total'
              leftIcon={
                <UxCircleArrowUp
                  sx={{
                    fontSize: 16,
                    marginRight: 0.5,
                  }}
                />
              }
              value={uploadTotal}
            />
            <CardInfo
              caption='Download total'
              leftIcon={
                <UxCircleArrowDown
                  sx={{
                    fontSize: 16,
                    marginRight: 0.5,
                  }}
                />
              }
              value={downloadTotal}
            />
          </Stack>
        </Box>
      </Stack>
    </Card>
  );
});
